
import Vue from "vue";

export default Vue.extend({
  name: "AIAgentLoader",
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    message: {
      type: String,
      default: "Analysing Resumes"
    }
  }
});
